import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router';

import { useAppDispatch } from 'app/hooks';
import {
  doFormMsg,
  FormMessage,
  FormMsg,
  NoFormMsg,
} from 'components/forms/FormMessage';
import { ModalDialog } from 'components/modal/Modal';
import { useModal } from 'components/modal/ModalContext';
import { navigateIn, navigateNow } from 'components/navigation/Navigation';
import { verifyMailAsync } from 'features/user/userSlice';
import { useUser } from 'selectors/userSelectors';

// TODO: replace the verifyMailForm with a code to be entered in
// the signup form. The code will be sent by mail, instead of the link
// to this form.
export default function UserVerifyMailForm() {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const {
    user,
    userId,
    // userLoggedIn
  } = useUser();

  const navigate = useNavigate();
  const { closeModal } = useModal();

  const [formMsg, setFormMsg] = useState<FormMsg>(NoFormMsg);
  const { token, regcode } = useParams();

  // we use the token parameter from the url to receive the token (see App.js)
  useEffect(() => {
    if (token) {
      dispatch(verifyMailAsync({ token: token, regcode: regcode })).then(
        (response: { payload: any }) => {
          switch (response.payload?.response.status) {
            case 204:
              doFormMsg(
                {
                  message: intl.formatMessage({
                    id: 'USERS.CONFIRM.SUCCESS',
                  }),
                  success: true,
                },
                setFormMsg,
              );
              // TODO: this is an attempt to login in automatically, but
              // not successful yet... can't seem to do it without the password,
              // we probably need some backend action to make this possible.
              // const decodedResponse: IDecodedResponse = jwtDecode(token);
              // const uId = decodedResponse?.data?.user?.id;
              // console.log('uId:', uId);
              // if (uId) {
              //   dispatch(setUserId(uId));
              //   // dispatch(fetchUserAsync(uId));
              // } else
              navigateIn('/login', 5000, navigate, closeModal);
              break;
            default:
              doFormMsg(
                {
                  message: intl.formatMessage({ id: 'USERS.CONFIRM.FAILED' }),
                  success: false,
                },
                setFormMsg,
              );
              break;
          }
        },
      );
    } else {
      navigate('/');
    }
  }, []);

  async function handleSubmit(): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      resolve(true);
      navigateNow('/login', navigate);
    });
  }

  return (
    <ModalDialog
      className="user_form narrow"
      title={<FormattedMessage id="USERS.CONFIRM.TITLE" />}
      okBtn={{
        onClick: handleSubmit,
      }}
      enableEscape
    >
      <p>
        <FormattedMessage id="USERS.CONFIRM.TEXT" />
      </p>
      <FormMessage {...formMsg} key={formMsg.key} />
    </ModalDialog>
  );
}
